import React from "react";
import "../styles/Header.scss";
import HeaderBreadcrumb from "./HeaderBreadcrumb";
import NotificationBell from "./NotificationBell";
import WhatsNewPopover from "./WhatsNewPopover";
import CommonHeader from "./CommonHeader";

// The dashboard header is a thin configuration of the shared
// <CommonHeader/>. currentScreen → breadcrumb, plan badge → planInfo,
// What's New + notifications passed in; profile defaults to <Logout/>.
const Header = ({ collapsed, onToggle, planInfo, hideBreadcrumb }) => {
    return (
        <CommonHeader
            planInfo={planInfo}
            currentScreen={<HeaderBreadcrumb className='mb-0' hide={hideBreadcrumb} />}
            whatsNew={<WhatsNewPopover />}
            notifications={<NotificationBell />}
        />
    );
};

export default Header;
